import Base from './base';
import focsusableElements from '../utils/focusable-elements';

class Navigation extends Base {
	constructor(el) {
		super(el);

		this.ctrl = this.query('[aria-controls]');

		const menuId = this.ctrl.getAttribute('aria-controls');

		this.menu = this.query(`#${menuId}`);

		this.on('click', this.ctrl);
	}

	get pressed() {
		return Navigation.isAttributeTrue(this.ctrl, 'aria-pressed');
	}

	set pressed(value) {
		const isPressed = Boolean(value);

		if (isPressed) {
			this.ctrl.setAttribute('aria-pressed', 'true');
		} else {
			this.ctrl.removeAttribute('aria-pressed');
		}
	}

	get expanded() {
		return Navigation.isAttributeTrue(this.menu, 'aria-expanded');
	}

	set expanded(value) {
		const isExpanded = Boolean(value);

		if (isExpanded) {
			this.menu.setAttribute('aria-expanded', 'true');
		} else {
			this.menu.removeAttribute('aria-expanded');
		}
	}

	onClick() {
		this.toggle();
	}

	toggle() {
		this.pressed = !this.pressed;
		this.expanded = !this.expanded;

		if (this.expanded) {
			this.focus();
		}
	}

	focus() {
		const [firstInput] = this.queryAll(focsusableElements, this.menu);

		if (firstInput) {
			firstInput.focus();
		}
	}

	static isAttributeTrue(el, attribute) {
		return el.hasAttribute(attribute) && el.getAttribute(attribute) === 'true';
	}
}

export default Navigation;

